import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import BundleBox from './BundleBox';
import { BREAKPOINT } from '@constants';
import { TextVariant, Typography } from './Typography';
import { ProductCode } from '@contracts';
import useProductPrices from '@utils/useProductPrices';

const ShoppingBundles: React.FC = () => {
  const { productHeaderData } = useShoppingContext();
  const { bundle_products_title, bundle_products } = productHeaderData;
  const productCodes = useMemo(() => bundle_products?.map((p) => p.bundle_product_code as ProductCode) || [], [bundle_products]);
  const productPrices = useProductPrices(productCodes);

  const containsValidPrices = useMemo(
    () => Object.values(productPrices).some((price) => price !== null && price !== undefined && price >= 0),
    [productPrices]
  );

  if (!bundle_products?.length || !containsValidPrices) {
    return null;
  }

  return (
    <Container>
      {bundle_products_title && (
        <Title>
          <Typography $variant={TextVariant.UpperText4} $mobileVariant={TextVariant.UpperText5}>
            {bundle_products_title}
          </Typography>
        </Title>
      )}
      {bundle_products.map((bundleData, index) => (
        <BundleBox key={index} bundleData={bundleData} />
      ))}
    </Container>
  );
};

export default ShoppingBundles;

const Container = styled.div`
  width: 100%;
`;

const Title = styled.div`
  margin-bottom: 16px;
  text-align: left;

  @media (max-width: ${BREAKPOINT.tablet}px) {
    margin-bottom: 20px;
  }
`;
